// Autogenerated file, DO NOT MODIFY or it will be overwritten;
import type { SVGProps } from 'react';

import { forwardRef } from '@chakra-ui/react';

import { Icon, type IconProps } from '../Icon';

const Svg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      stroke="#656D75"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M8.74537 11.2501L17.4954 2.50014M8.85169 11.5235L11.0418 17.1552C11.2347 17.6513 11.3312 17.8994 11.4702 17.9718C11.5907 18.0346 11.7342 18.0347 11.8548 17.972C11.9939 17.8998 12.0906 17.6518 12.2842 17.1559L17.7761 3.08281C17.9508 2.63516 18.0382 2.41133 17.9904 2.26831C17.9489 2.1441 17.8514 2.04663 17.7272 2.00514C17.5842 1.95736 17.3604 2.0447 16.9127 2.21939L2.83958 7.71134C2.34369 7.90486 2.09574 8.00163 2.02348 8.14071C1.96084 8.26129 1.96093 8.40483 2.02371 8.52533C2.09613 8.66433 2.34419 8.7608 2.84031 8.95373L8.47198 11.1438C8.57269 11.183 8.62304 11.2026 8.66544 11.2328C8.70302 11.2596 8.73589 11.2925 8.7627 11.3301C8.79294 11.3725 8.81252 11.4228 8.85169 11.5235Z"
    />
  </svg>
);
const IconPaperPlaneOutline = forwardRef(
  (props: Omit<IconProps, 'icon'>, ref) => {
    return <Icon ref={ref} icon={Svg} {...props} />;
  }
);
export default IconPaperPlaneOutline;
